module.exports = __webpack_public_path__ + "static/img/office_01.c139c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/office_01.png
// module id = XOGr
// module chunks = 0